import { render, staticRenderFns } from "./LanguageGrayBackground.vue?vue&type=template&id=d99ab25c&scoped=true&"
import script from "./LanguageGrayBackground.vue?vue&type=script&lang=js&"
export * from "./LanguageGrayBackground.vue?vue&type=script&lang=js&"
import style0 from "./LanguageGrayBackground.vue?vue&type=style&index=0&id=d99ab25c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99ab25c",
  null
  
)

export default component.exports